<template>
  <pt-anniversary-active-sign class="pt-anniversary-active-sign__withData"></pt-anniversary-active-sign>
</template>

<script>
import PtAnniversaryActiveSign from './index'
export default {
  name: 'pt-anniversary-active-sign__withData',
  components: {
    'pt-anniversary-active-sign': PtAnniversaryActiveSign
  }
}
</script>
